'use strict';

export default class PrizeGame2022 {

    constructor() {
        let form = document.getElementById('prize-game-form-2022');

        // is the element present on the current page
        if (!form) {
            return;
        }

        //upload file input
        const inputFile = document.querySelector('.file-upload-input');
        if(inputFile) {
            inputFile.addEventListener('change', () => {
                readURL(inputFile);
            });
            //Remove file
            const removeFile = document.querySelector('.remove-image');
            removeFile.addEventListener('click', () => {
                removeUpload();
            });
        }

        function readURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    $('.image-upload-wrap').hide();

                    $('.file-upload-image').attr('src', e.target.result);
                    $('.file-upload-content').show();

                    $('.image-title').html(input.files[0].name);
                };

                reader.readAsDataURL(input.files[0]);

            } else {
                removeUpload();
            }
        }

        function removeUpload() {
            //$('.file-upload-input').replaceWith($('.file-upload-input').clone());
            $('.file-upload-content').hide();
            $('.image-upload-wrap').show();
            $('.file-upload-input').val(null);
        }
        $('.image-upload-wrap').bind('dragover', function () {
            $('.image-upload-wrap').addClass('image-dropping');
        });
        $('.image-upload-wrap').bind('dragleave', function () {
            $('.image-upload-wrap').removeClass('image-dropping');
        });


        let input = form.querySelector('input[type="file"]'),
            label = form.querySelector('label'),
            submit = form.querySelector('#submitContestForm'),
            errorMsg = form.querySelector('.form-group__file .invalid-feedback')

        // if the form was submitted
        form.addEventListener('submit', e => {
            const eventsubmit = 'form-submit-' + $('.form #language').val() + '-prize2022';
            const eventsent = 'form-sent-' + $('.form #language').val() + '-prize2022';
            console.log(eventsubmit);
            console.log(eventsent);

                $('.invalid-number').hide();
                if (!$('#prize-game-form-2022')[0].checkValidity()) {
                    e.preventDefault();

                    $('input, textarea').each(function () {

                        if (!this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                } else {
                    e.preventDefault();
                    var file_data = $('.form #upload').prop('files')[0];
                    //Events tracking
                    ga('send', 'event', eventsubmit, eventsubmit, 'webpage');
                    plausible(eventsubmit);

                    var ajaxData = new FormData()

                    ajaxData.append('action', 'prize_game_form_2022');
                    ajaxData.append('name', $('.form #name').val());
                    ajaxData.append('last', $('.form #last').val());
                    ajaxData.append('email', $('.form #email').val());
                    ajaxData.append('phone', $('.form #phone').val());
                    ajaxData.append('street', $('.form #street').val());
                    ajaxData.append('building_number', $('.form #building_number').val());
                    ajaxData.append('apartment_number', $('.form #apartment_number').val());
                    ajaxData.append('zip_code', $('.form #zip_code').val());
                    ajaxData.append('city', $('.form #city').val());
                    ajaxData.append('number', $('.form #number').val());
                    ajaxData.append('date', $('.form #date').val());
                    ajaxData.append('id', $('.form #id').val());
                    ajaxData.append('nonce', $('.form #nonce').val());
                    ajaxData.append('file', file_data);
                    ajaxData.append('message', $('.form #message').val());
                    ajaxData.append('hour', $('.form #hour').val());
                    ajaxData.append('pageid', $('.form #pageid').val());


                    $.ajax({
                        url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
                        data: ajaxData,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (data) {
                            $('.prize__form').hide();
                            //document.querySelector('.logo').style.backgroundImage = 'url(/app/themes/argeta-timber/dist/images/svg/logo-argeta-orange.svg)';
                            $('.prize__confirmation').show();
                            //Events tracking
                            ga('send', 'event', eventsent, eventsent, 'webpage');
                            plausible(eventsent);

                            $([document.documentElement, document.body]).animate({
                                scrollTop: 0
                            }, 1000);
                        },
                        error: function (error) {
                            if (error.responseJSON.data.error === "Unsupported file") {
                                $('.invalid-file').slideDown();
                            } else {
                                $('.invalid-number').slideDown();
                            }

                        }
                    });
                }
        });

    }
}
